import { axiosInstance } from '../../config';
import ozonOrdersStore from '../../stores/OzonOrdersStore';
import { playScannerTone, unlockScannerAudio } from './scannerAudio';

export const RECENT_SCANS_KEY = 'mobileScannerRecentOrders';
export const SUCCESS_FLASH_MS = 500;
export const ERROR_FLASH_MS = 2000;

const listeners = new Set();
let busy = false;
let lastScan = { text: '', at: 0 };
let busyTimer = 0;

export const readRecentOrders = () => {
    try {
        const value = JSON.parse(localStorage.getItem(RECENT_SCANS_KEY) || '[]');
        return Array.isArray(value) ? value.slice(0, 100) : [];
    } catch {
        return [];
    }
};

const writeRecentOrders = (next) => {
    try {
        localStorage.setItem(RECENT_SCANS_KEY, JSON.stringify(next));
    } catch {
        // Список текущей сессии продолжит работать без localStorage.
    }
    return next;
};

export const subscribeScannerSession = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

const emit = (event) => {
    listeners.forEach((listener) => listener(event));
};

const addRecentOrder = (orderId) => {
    const next = [
        { orderId, scannedAt: new Date().toISOString() },
        ...readRecentOrders().filter((item) => item.orderId !== orderId),
    ].slice(0, 100);
    return writeRecentOrders(next);
};

export const clearRecentOrders = () => {
    writeRecentOrders([]);
    try {
        localStorage.removeItem(RECENT_SCANS_KEY);
    } catch {
        // Список уже очищен в памяти.
    }
    emit({ type: 'recent', recentOrders: [] });
};

const finishBusy = (delay) => {
    window.clearTimeout(busyTimer);
    busyTimer = window.setTimeout(() => {
        busy = false;
        emit({ type: 'processing', processing: false });
    }, delay);
};

export const processScannedCode = async (rawText) => {
    const text = String(rawText || '').trim();
    if (!text || busy) return null;

    const now = Date.now();
    if (lastScan.text === text && now - lastScan.at < 2500) {
        return null;
    }

    lastScan = { text, at: now };
    busy = true;
    unlockScannerAudio();
    emit({ type: 'processing', processing: true });

    try {
        const { data } = await axiosInstance.post('/v1/scanner/scan', {
            code: text,
        });

        if (!data?.found) {
            const lastResult = {
                type: 'error',
                scannedText: data?.scanned_text || text,
                message: 'Заказ не найден',
            };
            emit({
                type: 'result',
                lastResult,
                flash: 'error',
                flashMs: ERROR_FLASH_MS,
                recentOrders: readRecentOrders(),
            });
            playScannerTone('error');
            navigator.vibrate?.([180, 80, 180]);
            finishBusy(ERROR_FLASH_MS);
            return lastResult;
        }

        const orderId = data.order_id;
        const repeated =
            data.collect_inserted === false && data.check_inserted === false;
        const lastResult = {
            type: repeated ? 'repeat' : 'success',
            scannedText: data.scanned_text || text,
            orderId,
            message: repeated ? 'Заказ уже отсканирован' : 'Заказ добавлен',
        };
        const recentOrders = addRecentOrder(orderId);
        emit({
            type: 'result',
            lastResult,
            flash: repeated ? 'repeat' : 'success',
            flashMs: SUCCESS_FLASH_MS,
            recentOrders,
        });
        playScannerTone(repeated ? 'repeat' : 'success');
        navigator.vibrate?.(60);
        void ozonOrdersStore.fetchOrderStatuses();
        finishBusy(SUCCESS_FLASH_MS);
        return lastResult;
    } catch (error) {
        const lastResult = {
            type: 'error',
            scannedText: text,
            message:
                error.response?.data?.error?.message ||
                error.response?.data?.detail ||
                error.message ||
                'Не удалось проверить код',
        };
        emit({
            type: 'result',
            lastResult,
            flash: 'error',
            flashMs: ERROR_FLASH_MS,
            recentOrders: readRecentOrders(),
        });
        playScannerTone('error');
        navigator.vibrate?.([180, 80, 180]);
        finishBusy(ERROR_FLASH_MS);
        return lastResult;
    }
};
